import { render, staticRenderFns } from "./HSCodeUploadFileDialog.vue?vue&type=template&id=63c5bc0c&"
import script from "./HSCodeUploadFileDialog.vue?vue&type=script&lang=ts&"
export * from "./HSCodeUploadFileDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports